import {ChangeDetectionStrategy, Component} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import {PageComponent, PageMetadata} from '../../../core/seo/page-metadata'
import {OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {Observable, of} from 'rxjs'
import {ServiceOverviewPage} from '../../../core/content/types/service-overview-page.types'
import {Language} from '../../../core/i18n/language'

@Component({
  selector: 'bgo-service-overview-page',
  templateUrl: './service-overview-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceOverviewPageComponent extends PageComponent implements OptableLayout {
  page!: ServiceOverviewPage
  readonly optOutOfLayout = true

  constructor(private readonly route: ActivatedRoute) {
    super()
    this.page = this.route.snapshot.data['content']
  }

  getPageMetadata(): Observable<PageMetadata> {
    return of({
      title: this.page.title,
      description: this.page.description,
      doNotIndexPage: this.page.doNotIndexPage,
      canonicalUrl: this.page.canonicalUrl,
    })
  }

  getPageAvailableLanguages(): Observable<Language[] | undefined> {
    return of(this.page.availableLanguages)
  }
}
